import { InsightContentSettingType } from 'components/insightContent/types'
import { PivotWithCellMarker } from 'components/widget/CrosstabWidgets/types'
import { Pivot } from 'schemas/PivotSchema'
import ComparisonMode from 'enums/ComparisonMode'

const selectEntireColumn = (
  detailSetting: InsightContentSettingType,
  crossTabs: PivotWithCellMarker[]
) => {
  const {
    rowComparisonMode,
    topicId,
    selectedPivotRowThemeInfo,
    selectedRowTagName,
    selectedRowDocName
  } = detailSetting

  switch (rowComparisonMode) {
    case ComparisonMode.THEMES:
      return crossTabs?.filter(
        (crossTab: Pivot) => crossTab?.rowThemeId === selectedPivotRowThemeInfo.themeId!
      )

    case ComparisonMode.TAGS:
      return crossTabs?.filter((crossTab: Pivot) => crossTab?.rowTagName === selectedRowTagName)

    case ComparisonMode.DOC_HIERARCHIES:
      return crossTabs?.filter((crossTab: Pivot) => crossTab?.rowDocName === selectedRowDocName)

    default:
      return crossTabs?.filter((crossTab: Pivot) => crossTab?.topicId === topicId)
  }
}

export default selectEntireColumn
